<div class="w-full flex flex-wrap justify-center content-start">
    <span class="w-full text-base font-medium text-start mb-1">ثبت‌نام</span>
    <span class="w-full text-xs font-regular text-start mb-6">کد ارسال شده را وارد کن.</span>

    <!-- @if (initialData.type == 'email') {
        <span class="w-full text-sm font-regular text-center mb-2">کد ارسال‌شده به آدرس ایمیل را وارد کنید.</span>
        <span class="w-full text-sm font-regular text-center mb-2">{{initialData.userName}}</span>
    }
    @else {
        <span class="w-full text-sm font-regular text-center mb-2">کد ارسال‌شده به شماره {{initialData.userName}} را وارد کنید.</span>
    } -->

    <div class="w-full flex flex-wrap justify-center">
        <button class="btn btn-green-mute flex flex-wrap content-center items-center rounded-lg mb-6" (click)="changeUserName()">
            <span class="font-medium text-xs ml-2">{{initialData?.userName}}</span>
            <span class="icon edit-regular text-base"></span>
            <!-- @if (initialData.type == 'email') {
                ایمیل
            }
            @else {
                شمارهٔ موبایل
            } -->
        </button>

    </div>


    <app-otp-input class="w-2/3 md:w-5/12 mb-6" (codeCompleted)="verifyCode($event)"></app-otp-input>

    <div class="w-full text-center mb-6">
        @if(countdown === 0) {
        <span class="text-green-500 font-regular text-sm cursor-pointer" (click)="requestOtpCodeAgainHandler()">درخواست مجدد کد</span>
        } @else {
        <span class="text-gray-400 font-regular text-xs">{{countdown | counter}} تا ارسال مجدد کد</span>
        }
    </div>



    <button class="w-full btn btn btn-green-flat mb-2" [appButtonLoader]="verifyLoading" (click)="verifyCode()" [disabled]="code?.length != 4">تأیید و ادامه</button>
    <button class="w-full btn btn-green mb-5" (click)="loginWithPassword()">ورود با رمز عبور</button>

</div>